import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getScale = (state: RootState) => state.pages.editor.canvas.scale;

const getCanvasScale = createSelector([getScale], (scale) => scale);

export default getCanvasScale;
